// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const filterBoolean = <T extends any>(entity: T): entity is Exclude<T, boolean | undefined> => {
  return entity && typeof entity !== 'boolean';
};

export default filterBoolean;
